import { Component, OnInit } from '@angular/core';
@Component({
	selector: 'app-temporary',
	templateUrl: './temporary.component.html',
	styleUrls: ['./temporary.component.scss']
})
export class TemporaryComponent implements OnInit {

	constructor() {

	}

	ngOnInit() {

	}
}
